import { render, staticRenderFns } from "./classhour.vue?vue&type=template&id=59d43efe&scoped=true"
import script from "./classhour.vue?vue&type=script&lang=js"
export * from "./classhour.vue?vue&type=script&lang=js"
import style0 from "./classhour.vue?vue&type=style&index=0&id=59d43efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d43efe",
  null
  
)

export default component.exports